<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span class="modal-title">Sesiones Activas</span>
  <button mat-icon-button [mat-dialog-close] aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="modal-content">
  <table mat-table [dataSource]="data.sessions" class="sessions-table">
    <!-- Columna: Navegador -->
    <ng-container matColumnDef="userAgent">
      <th mat-header-cell *matHeaderCellDef>Navegador</th>
      <td mat-cell *matCellDef="let session">{{ getBrowserName(session.userAgent) }}</td>
    </ng-container>

    <!-- Columna: Dirección IP -->
    <ng-container matColumnDef="ipAddress">
      <th mat-header-cell *matHeaderCellDef>Dirección IP</th>
      <td mat-cell *matCellDef="let session">{{ session.ipAddress || 'Desconocida' }}</td>
    </ng-container>

    <!-- Columna: Creada -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Creada</th>
      <td mat-cell *matCellDef="let session">{{ session.createdAt | date: 'short' }}</td>
    </ng-container>

    <!-- Columna: Acción -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>Acción</th>
      <td mat-cell *matCellDef="let session">
        <button mat-button (click)="logoutSession(session.id)">Cerrar sesión</button>
      </td>
    </ng-container>

    <!-- Fila de la cabecera -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <!-- Fila de las sesiones -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</mat-dialog-content>
